<template>
    <div>
    <div class="dashboard-box stats-box w-full px-2 mb-5" v-if="!ignore_header">
            <v-card
            class="pa-2"
            tile
            >
            <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
                <div class="flex flex-row flex-wrap">
                <div class="w-full lg:w-2/3" style="position: relative;">
                    <strong class="mt-2 text-lg">{{ search.keyword }}</strong>

                    <div v-if="search.properties.business.website" class="website mt-1 text-sm"><a href="search.properties.business.website" target="lr-website-link" style="color: #2477F6 !important;">{{ search.properties.business.website }}</a></div>

                    <div class="clearfix pt-4"></div>

                    <div class="flex flex-row flex-wrap">
                    <div class="w-full lg:w-1/2" style="position: relative;">
                        <div class="mb-2" style="color: #757B89; font-size: 11px;">Address</div>

                        {{ search.properties.business.formatted_address }}
                    </div>

                    <div class="w-full lg:w-1/2" style="position: relative;">
                        <div class="mb-2" style="color: #757B89; font-size: 11px;">Phone</div>

                        {{ search.properties.business.formatted_phone_number }}
                    </div>

                    <div class="w-full lg:w-1/2 pt-5" style="position: relative;">
                        <div class="mb-2" style="color: #757B89; font-size: 11px;">Primary Category</div>

                        {{ ucwords(search.properties.business.types[0].replace(/\_/g, ' ')) }}
                    </div>

                    <div class="w-full lg:w-1/2 pt-5" style="position: relative;">
                        <div class="mb-2" style="color: #757B89; font-size: 11px;">Sub Category</div>

                        {{ ((search.properties.business.types[1]) ? ucwords(search.properties.business.types[1].replace(/\_/g, ' ')) : '-') }}
                    </div>
                    </div>

                    <div class="clearfix"></div>
                </div>

                <div class="lr-seo-audit-photo w-full lg:w-1/3">
                    <div v-if="search.properties.business.photos">
                        <img :src="'https://maps.googleapis.com/maps/api/place/photo?photo_reference=' + search.properties.business.photos[0].photo_reference + '&maxheight=200&key=AIzaSyBqF2vFVUoyeU3la0XVOQSOdkhgAfQdBEs'" />
                    </div>
                </div>
                </div>

                <br clear="all" />

                <hr />

                <v-tabs v-if="!$vuetify.breakpoint.xs" class="-mb-6" v-model="gmb_tab">
                    <v-tab>Top Competitors</v-tab>
                    <v-tab>Summary</v-tab>
                    <v-tab @click="show_grid = true">Grid Search Results</v-tab>
                    <v-tab>Review Analysis</v-tab>
                    <v-tab>Post Analysis</v-tab>
                    <v-tab>GBP Issues</v-tab>
                    <v-tab>Rcommendations <span v-if="search.properties.recommendations.items">({{ search.properties.recommendations.items.length }})</span></v-tab>
                </v-tabs>
            </div>
            </v-card>
        </div>



        <div v-show="gmb_tab == 0 || $vuetify.breakpoint.xs">
            <div :class="(($vuetify.breakpoint.xs) ? '' : 'px-3')">
                <strong :class="(($vuetify.breakpoint.xs) ? 'px-3' : 'pl-3')" style="font-size: 16px; color: #273042;">Top GBP Competitors vs Your Site</strong>

                <div class="pt-3" v-if="search.properties.competitors.list && search.properties.competitors.list.length > 0">
                    <div class="flex flex-row flex-wrap">
                        <div v-for="(competitor, index) in search.properties.competitors.list" :key="index" class="w-full lg:w-1/4" style="position: relative;">
                            <div class="dashboard-box stats-box w-full px-2 mb-5">
                                <v-card
                                    class="pa-2 pt-6 pb-6"
                                    tile
                                    :style="((competitor.my_business) ? 'background: #19233A;' : '')"
                                >
                                    <div style="width: 100px; color: #FFFFFF;  text-align: center; padding: 5px; font-weight: bold; margin: auto; background: #2477F6; border-radius: 23px;">Rank #{{ index + 1 }}</div>

                                    <div style="text-align: center; color: #313E42; font-weight: bold; padding: 15px; padding-bottom: 5px; font-size: 16px;"
                                        :style="((competitor.my_business) ? 'color: #FFFFFF;' : '')"
                                    ><a :href="'https://www.google.com/search?q=' + competitor.name + ' ' + competitor.address" target="lr-competitor">{{ competitor.name }}</a></div>

                                    <div style="text-align: center; color: #757B89; padding: 0px;"
                                        :style="((competitor.my_business) ? 'color: #FFFFFF;' : '')"
                                    >{{ competitor.address }}</div>

                                    <div class="pt-4 pl-2" style="font-size: 13px; display: flex;">
                                        <svg width="14" height="11" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.08203 8L5.09296 11L14.1176 1" stroke="#2477F6" stroke-width="2" stroke-linecap="round"/>
                                        </svg>

                                        <span style="color: #757B89; padding-left: 6px;">Main Category: <span style="color: #525254;" :style="((competitor.my_business) ? 'color: #FFFFFF;' : '')">{{ competitor.types[0].replace(/\_/g, " ") }}</span></span>
                                    </div>

                                    <div class="pt-4 pl-2" style="font-size: 13px; display: flex;">
                                        <svg width="14" height="11" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.08203 8L5.09296 11L14.1176 1" stroke="#2477F6" stroke-width="2" stroke-linecap="round"/>
                                        </svg>

                                        <span style="color: #757B89; padding-left: 6px;">Secondary Category: <span style="color: #525254;" :style="((competitor.my_business) ? 'color: #FFFFFF;' : '')">{{ ((competitor.types.length == 1) ? '-' : competitor.types[1].replace(/\_/g, " ")) }}</span></span>
                                    </div>

                                    <div class="pt-4 pl-2" style="font-size: 13px; display: flex;">
                                        <svg width="14" height="11" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.08203 8L5.09296 11L14.1176 1" stroke="#2477F6" stroke-width="2" stroke-linecap="round"/>
                                        </svg>

                                        <span style="color: #757B89; padding-left: 6px;">Number of Reviews: <span style="color: #525254;" :style="((competitor.my_business) ? 'color: #FFFFFF;' : '')">{{ competitor.user_ratings_total }}</span></span>
                                    </div>

                                    <div class="pt-4 pl-2" style="font-size: 13px; display: flex;">
                                        <svg width="14" height="11" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.08203 8L5.09296 11L14.1176 1" stroke="#2477F6" stroke-width="2" stroke-linecap="round"/>
                                        </svg>

                                        <span style="color: #757B89; padding-left: 6px;">Aggregate Rating: <span style="color: #525254;" :style="((competitor.my_business) ? 'color: #FFFFFF;' : '')">{{ competitor.rating }}</span></span>
                                    </div>

                                    <div class="pt-4 pl-2" style="font-size: 13px; display: flex;">
                                        <svg width="14" height="11" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.08203 8L5.09296 11L14.1176 1" stroke="#2477F6" stroke-width="2" stroke-linecap="round"/>
                                        </svg>

                                        <span style="color: #757B89; padding-left: 6px;">Citations: 
                                            <span style="color: #525254;" :style="((competitor.my_business) ? 'color: #FFFFFF;' : '')">
                                            <span v-if="competitor.citations_status == 'Error Occured'">
                                                Unable to process Citation details. Please delete this report and rerun GBP audit to refetch citations.
                                            </span>
                                             <span v-else>
                                                <span v-if="competitor.citations_status == 'completed'">{{ competitor.report_result.active.length }}</span>
                                                <span v-else><i class="fa fa-spin fa-spinner"></i></span>
                                             </span>
                                            </span>
                                        </span>
                                    </div>
                                </v-card>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="pt-3">
                    <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                </div>

                <div :class="'text-bold ' + (($vuetify.breakpoint.xs) ? 'px-3' : 'pl-3')" style="font-size: 16px; color: #273042;">How {{ search.properties.business.name }} compares to these Top 3 competitors?</div>

                <div v-if="search.properties.short_summary.grade" class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                        <v-card
                            class="pa-2 pt-6 pb-6"
                            tile

                            :class="(($vuetify.breakpoint.xs) ? 'pl-4' : '')"
                        >
                        <div class="flex flex-row flex-wrap">
                            <div class="w-full lg:w-1/2" style="position: relative;">
                            <div class="lr-seo-box-left">
                                <div class="lr-doughnut-wrapper">
                                <div class="lr-doughnut-title">
                                    {{ search.properties.short_summary.grade.value }}
                                </div>
                                    <apexchart type="donut" :options="shortSummaryDoughnut.chartOptions" :series="shortSummaryDoughnut.series" width="200"></apexchart>
                                </div>
                            </div>

                            <div class="lr-seo-box-right pt-4">
                                <div class="" style="font-size: 20px; font-weight: bold;">
                                    {{ search.properties.short_summary.grade.title }}
                                </div>

                                <div style="color: #757B89; font-size: 12px;">
                                    {{ search.properties.short_summary.grade.description }}
                                </div>
                            </div>

                            <div class="clearfix"></div>
                            </div>
                        </div>

                        <div :class="(($vuetify.breakpoint.xs) ? 'pr-2' : 'px-5')">
                            <div v-if="search.properties.short_summary.items" style="border: 1px solid #D9D9D9; border-radius: 5px; padding: 15px; margin-top: 20px;">
                                <div v-for="(item, index) in search.properties.short_summary.items" :key="index">
                                    <div style="clear: both; /*cursor: pointer;*/" @click="/*showSeoOnPageCategoryDescription(item.title, item.description)*/">
                                        <div class="float-left pr-2" style="width: 25px;">
                                            <div v-if="search.properties.competitors.status == 'pending' && item.title == 'Citations'">
                                                <i class="mdi mdi-information-outline" style="color: #757B89; font-size: 18px;"></i>
                                            </div>
                                            <div v-else>
                                                <i v-if="item.passed === true" class="mdi mdi-check" style="color: #54AC0E; font-size: 18px;"></i>
                                                <i v-if="item.passed === null" class="mdi mdi-information-outline" style="color: #757B89; font-size: 18px;"></i>
                                                <i v-if="item.passed === false" class="mdi mdi-close" style="color: #EA170C; font-size: 18px;"></i>
                                            </div>
                                        </div>

                                        <div class="float-left" style="width: calc(100% - 25px);">
                                        <div style="font-weight: bold; font-size: 16px;">{{ item.title }}</div>

                                        <div v-if="search.properties.competitors.status == 'pending' && item.title == 'Citations'">
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                        <div v-else>

                                            <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                {{ item.sub_title }}
                                            </div>

                                            <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                {{ item.description }}
                                            </div>
                                        </div>
                                    </div>

                                    <div style="clear: both;"></div>  
                                    <hr v-if="item.title != 'Citations'" class="mt-5 mb-5" />
                                    </div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </div>
                        </v-card>
                </div>
                <div v-else class="pt-3">
                    <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                </div>
            </div>
        </div>

        <div v-show="gmb_tab == 1 || $vuetify.breakpoint.xs">
            <div :class="'text-bold ' + (($vuetify.breakpoint.xs) ? '' : 'px-3')">
                <!-- <div :class="'text-bold ' + (($vuetify.breakpoint.xs) ? 'px-3' : '')" style="font-size: 16px; color: #273042;">Overview</div> -->

                <div v-if="search.properties.summary.grade">
                    <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                            <v-card
                                class="pa-2 pt-6 pb-6"
                                tile

                                :class="(($vuetify.breakpoint.xs) ? 'pl-4' : '')"
                            >
                            <div class="flex flex-row flex-wrap">
                                <div class="w-full lg:w-1/2" style="position: relative;">
                                <div class="lr-seo-box-left">
                                    <div class="lr-doughnut-wrapper">
                                    <div class="lr-doughnut-title">
                                        {{ search.properties.summary.grade.value }}
                                    </div>
                                        <apexchart type="donut" :options="summaryDoughnut.chartOptions" :series="summaryDoughnut.series" width="200"></apexchart>
                                    </div>
                                </div>

                                <div class="lr-seo-box-right pt-4">
                                    <div class="" style="font-size: 20px; font-weight: bold;">
                                        {{ search.properties.summary.grade.title }}
                                    </div>

                                    <div style="color: #757B89; font-size: 12px;">
                                        {{ search.properties.summary.grade.description }}
                                    </div>
                                </div>

                                <div class="clearfix"></div>
                                </div>
                            </div>
                        </v-card>
                    </div>

                    <div class="flex flex-row flex-wrap">
                        <div class="w-full lg:w-2/3" style="position: relative;">
                            <div v-if="search.properties.summary.left_items" style="">
                                <div v-for="(item, index) in search.properties.summary.left_items" :key="index">
                                    <div v-if="search.properties.summary.grade" class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                        <v-card
                                            class="pa-2 pt-2 pb-6"
                                            tile
                                        >
                                            <div style="/*cursor: pointer;*/" @click="/*showSeoOnPageCategoryDescription(item.title, item.description)*/">
                                                <div class="float-right pr-2">
                                                    <span v-if="item.passed === true"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i> Passed</span>
                                                    <span v-if="item.passed === false"><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i> Failed</span>
                                                </div>

                                                <div style="padding: 10px;">
                                                    <div style="font-weight: bold; font-size: 16px;">{{ item.title }}</div>

                                                    <div v-if="item.sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        {{ item.sub_title }}
                                                    </div>

                                                    <div v-if="item.sub_sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        {{ item.sub_sub_title }}
                                                    </div>

                                                    <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        {{ item.description }}
                                                    </div>

                                                    <div v-if="item.title == 'Business Name'" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        Business Name: <strong>{{ search.properties.business.name }}</strong>
                                                    </div>

                                                    <div v-if="item.title == 'Business Description' && item.business_description" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        <strong>Business Description:</strong> <div style="display: inline-block;" v-html="item.business_description"></div>
                                                    </div>

                                                    <div v-if="item.title == 'Business Category'" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        Business Categories: 
                                                        
                                                        <span v-for="(item, index) in search.properties.business.types" :key="index" style="font-weight: bold;">
                                                            {{ item.replace(/\_/g, " ") }}
                                                        </span>
                                                    </div>

                                                    <div v-if="item.title == 'Images'" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        <div class="flex flex-row flex-wrap">
                                                            <div class="w-full lg:w-1/6" style="position: relative; text-align: center; padding: 10px;" v-for="(photo, index) in search.properties.business.photos" :key="index">
                                                                <img :src="'https://maps.googleapis.com/maps/api/place/photo?maxheight=100&photo_reference=' + photo.photo_reference + '&key=' + search.api_key" :style="(($vuetify.breakpoint.xs) ? '' : 'max-width: 100px; max-height: 100px;')" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div v-if="item.title == 'Reviews'" :class="'py-2'">
                                                        <div class="lr-report-subtitle">Overall Ratings</div>

                                                        <div class="stats-box-number large">{{ search.properties.business.rating || 0 }}</div>
                                                        
                                                        <div class="stats-box-icon-bg" style="top: 100px;"></div>
                                                        <div class="stats-box-icon" style="top: 100px;">
                                                        <i class="mdi mdi-star"></i>
                                                        </div>

                                                        <div class="clearfix"></div>
                                                        
                                                        <div style="float: left;">
                                                        <v-rating
                                                            class="mt-1 -ml-1"
                                                            :value="(parseFloat(search.properties.business.rating) || 0)"
                                                            :color="'orange ligten-1'"
                                                            dense
                                                            half-increments
                                                            readonly
                                                            size="20"
                                                        ></v-rating>
                                                        </div>
                                                        
                                                        <div class="text-sm pl-2" style="color: #757575; float: left; font-size: 12px; padding-top: 7px;">
                                                        Based on

                                                        <span class="mr-1">{{ search.properties.business.user_ratings_total || 0 }}</span>

                                                        <span class="text-gray-600" v-show="search.properties.business.user_ratings_total == 1">Review</span>
                                                        <span class="text-gray-600" v-show="search.properties.business.user_ratings_total != 1">Reviews</span>
                                                        </div>

                                                        <div class="clearfix"></div>

                                                        <hr class="mt-3" />
                                                    </div>

                                                    <div v-if="item.title == 'Reviews'" v-html="reviews_html" style="padding-top: 10px; color: #757B89; font-size: 12px;"></div>
                                                </div>

                                            <div style="clear: both;"></div>  

                                            </div>
                                        </v-card>
                                    </div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </div>

                        <div class="w-full lg:w-1/3" style="position: relative;">
                            <div v-if="search.properties.summary.right_items" style="">
                                <div v-for="(item, index) in search.properties.summary.right_items" :key="index">
                                    <div v-if="search.properties.summary.grade" class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                        <v-card
                                            class="pa-2 pt-2 pb-6"
                                            tile
                                        >
                                            <div style="/*cursor: pointer;*/" @click="/*showSeoOnPageCategoryDescription(item.title, item.description)*/">
                                                <div class="float-right pr-2">
                                                    <span v-if="item.passed === true"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i> Passed</span>
                                                    <span v-if="item.passed === false"><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i> Failed</span>
                                                </div>

                                                <div style="padding: 10px;">
                                                    <div style="font-weight: bold; font-size: 16px;">{{ item.title }}</div>

                                                    <div v-if="item.sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        {{ item.sub_title }}
                                                    </div>

                                                    <div v-if="item.sub_sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        {{ item.sub_sub_title }}
                                                    </div>

                                                    <div style="padding-top: 10px; color: #757B89; font-size: 12px; font-weight: bold;">
                                                        {{ item.description }}
                                                    </div>

                                                    <div v-if="item.title == 'Address' && item.passed" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        Area Served: <div style="font-weight: bold; padding-top: 10px;">{{ item.area_served }}</div>
                                                    </div>

                                                    <div v-if="item.title == 'Phone Number' && item.passed" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        Your Business Phone: <div style="font-weight: bold; padding-top: 10px;">{{ item.phone_number }}</div>
                                                    </div>

                                                    <div v-if="item.title == 'Website / URL' && item.passed" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        Your Business Website / URL: <div style="font-weight: bold; padding-top: 10px;"><a :href="item.website" target="lr-gmb-website">{{ item.website }}</a></div>
                                                    </div>

                                                    <div v-if="item.title == 'Business Hours' && item.passed" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        <div class="mb-2"><strong style="font-size: 14px;">Your Business Hours</strong></div>
                                                        <div v-for="(business_item, index2) in item.weekday_text" :key="index2">
                                                            {{ business_item }}

                                                            <div style="clear: both;"></div>

                                                            <hr class="mt-2 mb-2" />
                                                        </div>
                                                    </div>

                                                    <div v-if="item.title == 'Checklist'" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        <div v-for="(checklist_item, index3) in item.checklist" style="width: 50%; display: inline-block;" :key="index3">
                                                            <label>
                                                                <v-checkbox :label="checklist_item.title" v-model="checklist_item.checked"></v-checkbox>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div v-if="item.title == 'Missing Citations'" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        <div v-if="search.properties.competitors.status == 'completed'">
                                                            <div v-if="search.properties.business.citations_report.possible">
                                                                <div v-for="(item_citation, index_citation, counter) in search.properties.business.citations_report.possible" :key="index_citation">
                                                                    <strong class="pr-2">{{ (counter + 1) }}. </strong>
                                                                    <a :href="'https://' + item_citation.source" target="lr-missing-citation">{{ item_citation.source }}</a>

                                                                    <div v-if="item_citation['citation-value'] == 'Very High' || item_citation['citation-value'] == 'High'" style="padding: 8px 15px; display: inline-block; margin-left: 20px; font-size: 12px; background: rgba(36, 119, 246, 0.1); color: #2477F6; border-radius: 30px;">
                                                                        Well Known
                                                                    </div>
                                                                    <div v-else style="padding: 8px 15px; display: inline-block; margin-left: 20px; font-size: 12px; background: rgba(25, 35, 58, 0.05); color: #19233A; border-radius: 30px;">
                                                                        Local
                                                                    </div>

                                                                    <div style="clear: both;"></div>

                                                                    <hr class="mt-2 mb-2" />
                                                                </div>
                                                            </div>
                                                            <div v-else>
                                                                No missing citations.
                                                            </div>
                                                        </div>
                                                        <div v-else><i class="fa fa-spin fa-spinner"></i></div>
                                                    </div>
                                                </div>

                                            <div style="clear: both;"></div>  

                                            </div>
                                        </v-card>
                                    </div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="pt-3" :class="(($vuetify.breakpoint.xs) ? 'px-3' : '')">
                    <v-skeleton-loader type="article, article, article, article, article, article, article"></v-skeleton-loader>
                </div>
            </div>
        </div>

        <div v-show="gmb_tab == 2 || $vuetify.breakpoint.xs">
            <div class="dashboard-box stats-box w-full px-2 mb-5">
                <v-card
                    class="pa-2"
                    tile
                >
                    <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
                        <iframe v-if="loaded && (show_grid || $vuetify.breakpoint.xs)" :src="'/grid-tracker/app_for_gmb.html'" :style="(($vuetify.breakpoint.xs) ? 'width: 100%; height: 400px;' : 'width: 100%; height: 850px;')"></iframe>
                    </div>
                </v-card>
            </div>
        </div>

        <div v-show="gmb_tab == 3 || $vuetify.breakpoint.xs || this.$route.query.download">
            <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? '' : 'px-3')">
                <div v-if="search.properties.reviews.grade">
                    <div>
                        <div v-if="search.properties.reviews.status === 'Error Occured'">
                            <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                <v-card
                                        class="pa-2 pt-6 pb-6"
                                        tile

                                        :class="(($vuetify.breakpoint.xs) ? 'pl-3' : '')"
                                    >
                                        <div class="flex flex-row flex-wrap">
                                            <div class="w-full" style="position: relative;">

                                                <div class="lr-seo-box-right pt-3">
                                                    <strong class=""> Error :</strong> We are facing some delays because of API failure. We are retrying to fetch results for this report.
                                                </div>

                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                </v-card>
                            </div>
                        </div>

                        <div v-else class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                <v-card
                                    class="pa-2 pt-6 pb-6"
                                    tile

                                    :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'pl-3' : '')"
                                >
                                <div class="flex flex-row flex-wrap">
                                    <div class="w-full lg:w-1/2" style="position: relative;">
                                        <div class="lr-seo-box-left">
                                            <div class="lr-doughnut-wrapper">
                                            <div class="lr-doughnut-title">
                                                {{ search.properties.reviews.grade.value }}
                                            </div>
                                                <apexchart type="donut" :options="reviewsDoughnut.chartOptions" :series="reviewsDoughnut.series" width="200"></apexchart>
                                            </div>
                                        </div>

                                        <div class="lr-seo-box-right pt-4">
                                            <div class="" style="font-size: 20px; font-weight: bold;">
                                                {{ search.properties.reviews.grade.title }}
                                            </div>

                                            <div style="color: #757B89; font-size: 12px;">
                                                {{ search.properties.reviews.grade.description }}
                                            </div>
                                        </div>

                                        <div class="clearfix"></div>
                                    </div>

                                    <div class="w-full lg:w-1/2" :style="'position: relative; ' + (($vuetify.breakpoint.xs) ? '' : 'border-left: solid 1px rgba(0, 0, 0, 0.1); padding-left: 30px;') + ' '">
                                        <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'pt-2' : 'float-right pr-2')">
                                            <span v-if="search.properties.reviews.grade.value == 'A+'"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i> Passed</span>
                                            <span v-if="search.properties.reviews.grade.value != 'A+'"><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i> Failed</span>
                                        </div>
                                        
                                        <div v-if="search.properties.gbp_issues.items" style="">
                                            <div :style="(($vuetify.breakpoint.xs) ? 'padding-top: 10px;' : 'padding-top: 25px;')">
                                                <span v-if="search.properties.business.user_ratings_total > 100"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i>  Reviews</span>
                                                <span v-else><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i>  Reviews</span>
                                            </div>

                                            <div :style="(($vuetify.breakpoint.xs) ? 'padding-top: 10px;' : 'padding-top: 25px;')">
                                                <span v-if="search.properties.business.rating >= 4.5"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i>  Rating</span>
                                                <span v-else><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i>  Rating</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                        </div>
                    </div>
                    <div>
                        
                    <div>
                        <div v-if="search.properties.reviews.status === 'Error Occured'">
                            <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                <v-card
                                        class="pa-2 pt-6 pb-6"
                                        tile

                                        :class="(($vuetify.breakpoint.xs) ? 'pl-3' : '')"
                                    >
                                        <div class="flex flex-row flex-wrap">
                                            <div class="w-full" style="position: relative;">

                                                <div class="lr-seo-box-right pt-3">
                                                    <strong class=""> Error :</strong> We are facing some delays because of API failure. We are retrying to fetch results for this report.
                                                </div>

                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                </v-card>
                            </div>
                        </div>
                        <div v-else class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                            <v-card
                                class="pa-2 pt-2 pb-6"
                                tile
                            >
                                <v-container class="chart-container">
                                    <apexchart height="205" type="line" :options="reviews_options" :series="reviews_series" :key="reviews_chart_key"></apexchart>
                                </v-container>
                            </v-card>
                        </div>
                    </div>

                    </div>

                    <div class="flex flex-row flex-wrap">
                        <div class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 mb-5">
                        <v-card
                            class="pa-2"
                            tile
                        >
                            <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                            <div class="dashboard-box-title">Total Reviews</div>

                            <div class=""><strong class="text-xl">{{ search.properties.business.user_ratings_total }}</strong></div>
                            
                            <div class="stats-box-icon-bg"></div>
                            <div class="stats-box-icon">
                                <i class="mdi mdi-star-box"></i>
                            </div>
                            </div>
                        </v-card>
                        </div>

                        <div class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 mb-5">
                        <v-card
                            class="pa-2"
                            tile
                        >
                            <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                            <div class="dashboard-box-title">Average Rating</div>

                            <div class=""><strong class="text-xl">{{ search.properties.business.rating }}</strong></div>
                            
                            <div class="stats-box-icon-bg"></div>
                            <div class="stats-box-icon">
                                <i class="mdi mdi-star"></i>
                            </div>
                            </div>
                        </v-card>
                        </div>
                        
                    </div>


                    <div v-if="this.google_review_enabled !== null" class="flex flex-row flex-wrap">
                        <div class="flex flex-row flex-wrap" v-if="this.google_review_enabled === 1 && this.google_local_guide === 1">
                            <div v-if="search.properties.reviews.status !== 'Error Occured'" class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">No. Of Reviews With Photos</div>

                                <div class=""><strong class="text-xl">{{ search.properties.reviews.reviews_with_photos }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-image-area"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                            <div v-if="search.properties.reviews.status !== 'Error Occured'"  class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">No. Of Reviews Provided By Local Guides</div>

                                <div class=""><strong class="text-xl">{{ search.properties.reviews.reviews_by_local_guides }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-account-star"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                            <div v-if="search.properties.reviews.status !== 'Error Occured'"  class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Average Number of Reviews By Others</div>

                                <div class=""><strong class="text-xl">{{ search.properties.reviews.reviews_by_others }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-account"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>
                        </div>

                        <div class="flex flex-row flex-wrap" v-else-if="this.google_review_enabled === 1">
                            <div v-if="search.properties.reviews.status !== 'Error Occured'" class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">No. Of Reviews With Photos</div>

                                <div class=""><strong class="text-xl">{{ search.properties.reviews.reviews_with_photos }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-image-area"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                            <div v-if="search.properties.reviews.status !== 'Error Occured'"  class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Average Number of Reviews By Others</div>

                                <div class=""><strong class="text-xl">{{ search.properties.reviews.reviews_by_others }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-account"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                        </div>

                        <div class="flex flex-row flex-wrap" v-else-if="this.google_local_guide === 1">

                            <div v-if="search.properties.reviews.status !== 'Error Occured'"  class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">No. Of Reviews Provided By Local Guides</div>

                                <div class=""><strong class="text-xl">{{ search.properties.reviews.reviews_by_local_guides }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-account-star"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                            <div v-if="search.properties.reviews.status !== 'Error Occured'"  class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Average Number of Reviews By Others</div>

                                <div class=""><strong class="text-xl">{{ search.properties.reviews.reviews_by_others }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-account"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>
                        </div>

                        <div class="flex flex-row flex-wrap" v-else>
                            <div v-if="search.properties.reviews.status !== 'Error Occured'"  class="dashboard-box stats-box w-full px-2  mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Average Number of Reviews By Others</div>

                                <div class=""><strong class="text-xl">{{ search.properties.reviews.reviews_by_others }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-account"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                        </div>

                    </div>


                    <div v-else class="pt-3 mb-3">

                        <v-skeleton-loader type="article"></v-skeleton-loader>
                    </div>

                    <div class="flex flex-row flex-wrap">
                        <div class="w-full" style="position: relative;">
                            <div style="">
                                <div>
                                    <div class="dashboard-box stats-box w-full px-2">
                                        <v-card
                                            class="pa-2 pt-2 pb-6"
                                            tile
                                        >
                                            <div style="/*cursor: pointer;*/" @click="/*showSeoOnPageCategoryDescription(item.title, item.description)*/">
                                                <div style="padding: 10px;">
                                                    <div style="font-weight: bold; font-size: 16px;">Number of Reviews</div>

                                                    <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        Google reviews are important because they help showcase your company's reputation, they increase sales and improve search rankings for your website. See how your compare with other businesses.
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="search.properties.reviews.status !== 'Error Occured'"  class="flex flex-row flex-wrap">
                        <div v-for="(item2, index2) in search.properties.competitors.list" :key="index2" class="dashboard-box stats-box w-full px-2 mb-5 mt-3" :class="'lg:w-1/' + search.properties.competitors.list.length">
                            <v-card class="pa-2" tile :style="((item2.my_business) ? 'background: #19233A; color: #FFFFFF !important;' : '')">
                                <div class="p-2 pl-3" style="position: relative;">
                                    <div style="position: absolute; padding-top: 0px; right: 10px;">

                                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute;">
                                        <rect opacity="0.1" x="0.589844" y="0.5" width="50" height="50" rx="10" :fill="((item2.my_business) ? '#FFFFFF' : '#3EBB80')"/>
                                        </svg>

                                        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 5px; margin-top: 5px;">
                                            <path d="M8.91996 7C7.3599 7 6.08984 8.27097 6.08984 9.83103V27.1933C6.08984 28.7534 7.35996 30.0243 8.91996 30.0243H17.5314L20.1338 35.7081C20.2149 35.8869 20.393 36.0018 20.5894 36.0018C20.7859 36.0018 20.964 35.8869 21.045 35.7081L23.6475 30.0243H32.2578C33.8178 30.0243 35.0888 28.7534 35.0888 27.1933V9.83103C35.0888 8.27097 33.8176 7 32.2578 7H8.91996ZM8.91996 8H32.2577C33.2813 8 34.0887 8.80737 34.0887 9.83103V27.1933C34.0887 28.217 33.2813 29.0234 32.2577 29.0234H23.3262C23.1307 29.0237 22.9535 29.1377 22.8722 29.3154L20.591 34.2977L18.3068 29.3154H18.3066C18.2253 29.1377 18.0481 29.0237 17.8526 29.0234H8.91999C7.89633 29.0234 7.08987 28.217 7.08987 27.1933V9.83103C7.08987 8.80737 7.89633 8 8.91999 8H8.91996ZM20.5565 11.4942H20.5563C20.3552 11.5071 20.1815 11.6397 20.1159 11.8301L18.5349 16.3741L13.7175 16.4737C13.5049 16.4786 13.3188 16.6172 13.2534 16.8192C13.188 17.0212 13.2574 17.2424 13.4266 17.371L17.2635 20.2793L15.8708 24.8846C15.8086 25.0884 15.8822 25.309 16.0545 25.4344C16.2266 25.5599 16.4594 25.5628 16.6344 25.4413L20.5884 22.6913L24.5436 25.4413H24.5438C24.7188 25.5628 24.9516 25.5599 25.1237 25.4344C25.296 25.309 25.3697 25.0884 25.3074 24.8846L23.9118 20.2793L27.7507 17.371C27.9201 17.2422 27.9895 17.0205 27.9235 16.8183C27.8574 16.6161 27.6705 16.4777 27.4578 16.4737L22.6433 16.3741L21.0623 11.8301C20.9886 11.6169 20.7815 11.4792 20.5563 11.4942H20.5565ZM20.5887 13.5167L21.8123 17.0323V17.0321C21.8809 17.2299 22.0657 17.364 22.2751 17.3681L26.0007 17.4433L23.03 19.6913C22.8623 19.8178 22.7918 20.0355 22.8532 20.2364L23.9333 23.798L20.8737 21.6729V21.6727C20.7025 21.5544 20.4757 21.5544 20.3045 21.6727L17.2449 23.7977L18.323 20.2361V20.2364C18.3842 20.0355 18.3132 19.8176 18.1453 19.6913L15.1775 17.4433L18.9031 17.3681C19.1125 17.364 19.2973 17.2299 19.3658 17.0321L20.5887 13.5167Z" :fill="((item2.my_business) ? '#FFFFFF' : '#3EBB80')" :stroke="((item2.my_business) ? '#FFFFFF' : '#3EBB80')" stroke-width="0.5"/>
                                        </svg>
                                    </div>
                                    <div class="dashboard-box-title" style="width: calc(100% - 70px);"><a style="font-size: 12px;" :style="((item2.my_business) ? 'color: #FFFFFF !important;' : 'color: #19233A !important;')" :href="'https://www.google.com/search?q=' + encodeURIComponent(item2.name) + ' ' + item2.address" target="lr-competitor">{{ ((item2.my_business) ? "Your Business" : item2.name) }}</a></div>

                                    <div class="details-box top-heading" style="width: calc(100% - 70px);">{{ item2.user_ratings_total }}</div>
                                </div>
                            </v-card>
                        </div>
                    </div>

                    <div  class="flex flex-row flex-wrap mt-3">
                        <div class="w-full" style="position: relative;">
                            <div style="">
                                <div>
                                    <div class="dashboard-box stats-box w-full px-2">
                                        <v-card
                                            class="pa-2 pt-2 pb-6"
                                            tile
                                        >
                                            <div style="/*cursor: pointer;*/" @click="/*showSeoOnPageCategoryDescription(item.title, item.description)*/">
                                                <div style="padding: 10px;">
                                                    <div style="font-weight: bold; font-size: 16px;">Aggregate Rating</div>

                                                    <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        A good average rating is also important for building a good reputation online.
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="search.properties.reviews.status !== 'Error Occured'"  class="flex flex-row flex-wrap">
                        <div v-for="(item2, index2) in search.properties.competitors.list" :key="index2" class="dashboard-box stats-box w-full px-2 mb-5 mt-3" :class="'lg:w-1/' + search.properties.competitors.list.length">
                            <v-card class="pa-2" tile :style="((item2.my_business) ? 'background: #19233A; color: #FFFFFF !important;' : '')">
                                <div class="p-2 pl-3" style="position: relative;">
                                    <div style="position: absolute; padding-top: 0px; right: 10px;">

                                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute;">
                                            <rect opacity="0.1" x="0.589844" y="0.5" width="50" height="50" rx="10" :fill="((item2.my_business) ? '#FFFFFF' : '#3EBB80')"/>
                                        </svg>

                                        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 5px; margin-top: 5px;">
                                            <path d="M8.91996 7C7.3599 7 6.08984 8.27097 6.08984 9.83103V27.1933C6.08984 28.7534 7.35996 30.0243 8.91996 30.0243H17.5314L20.1338 35.7081C20.2149 35.8869 20.393 36.0018 20.5894 36.0018C20.7859 36.0018 20.964 35.8869 21.045 35.7081L23.6475 30.0243H32.2578C33.8178 30.0243 35.0888 28.7534 35.0888 27.1933V9.83103C35.0888 8.27097 33.8176 7 32.2578 7H8.91996ZM8.91996 8H32.2577C33.2813 8 34.0887 8.80737 34.0887 9.83103V27.1933C34.0887 28.217 33.2813 29.0234 32.2577 29.0234H23.3262C23.1307 29.0237 22.9535 29.1377 22.8722 29.3154L20.591 34.2977L18.3068 29.3154H18.3066C18.2253 29.1377 18.0481 29.0237 17.8526 29.0234H8.91999C7.89633 29.0234 7.08987 28.217 7.08987 27.1933V9.83103C7.08987 8.80737 7.89633 8 8.91999 8H8.91996ZM20.5565 11.4942H20.5563C20.3552 11.5071 20.1815 11.6397 20.1159 11.8301L18.5349 16.3741L13.7175 16.4737C13.5049 16.4786 13.3188 16.6172 13.2534 16.8192C13.188 17.0212 13.2574 17.2424 13.4266 17.371L17.2635 20.2793L15.8708 24.8846C15.8086 25.0884 15.8822 25.309 16.0545 25.4344C16.2266 25.5599 16.4594 25.5628 16.6344 25.4413L20.5884 22.6913L24.5436 25.4413H24.5438C24.7188 25.5628 24.9516 25.5599 25.1237 25.4344C25.296 25.309 25.3697 25.0884 25.3074 24.8846L23.9118 20.2793L27.7507 17.371C27.9201 17.2422 27.9895 17.0205 27.9235 16.8183C27.8574 16.6161 27.6705 16.4777 27.4578 16.4737L22.6433 16.3741L21.0623 11.8301C20.9886 11.6169 20.7815 11.4792 20.5563 11.4942H20.5565ZM20.5887 13.5167L21.8123 17.0323V17.0321C21.8809 17.2299 22.0657 17.364 22.2751 17.3681L26.0007 17.4433L23.03 19.6913C22.8623 19.8178 22.7918 20.0355 22.8532 20.2364L23.9333 23.798L20.8737 21.6729V21.6727C20.7025 21.5544 20.4757 21.5544 20.3045 21.6727L17.2449 23.7977L18.323 20.2361V20.2364C18.3842 20.0355 18.3132 19.8176 18.1453 19.6913L15.1775 17.4433L18.9031 17.3681C19.1125 17.364 19.2973 17.2299 19.3658 17.0321L20.5887 13.5167Z" :fill="((item2.my_business) ? '#FFFFFF' : '#3EBB80')" :stroke="((item2.my_business) ? '#FFFFFF' : '#3EBB80')" stroke-width="0.5"/>
                                        </svg>
                                    </div>
                                    <div class="dashboard-box-title" style="width: calc(100% - 70px);"><a style="font-size: 12px;" :style="((item2.my_business) ? 'color: #FFFFFF !important;' : 'color: #19233A !important;')" :href="'https://www.google.com/search?q=' + encodeURIComponent(item2.name) + ' ' + item2.address" target="lr-competitor">{{ ((item2.my_business) ? "Your Business" : item2.name) }}</a></div>

                                    <div class="details-box top-heading" style="width: calc(100% - 70px);">{{ item2.rating }}</div>
                                </div>
                            </v-card>
                        </div>
                    </div>

                    <div class="flex flex-row flex-wrap mb-4 pt-3">
                        <div class="dashboard-box stats-box w-full px-2 md:w-2/3 lg:w-2/3 mb-5">
                        <v-card
                            class="pa-2"
                            tile
                        >
                            <div class="p-2">
                                <div class="lr-report-subtitle">Average Ratings</div>

                                <div class="stats-box-number large">{{ search.properties.business.rating || 0 }}</div>
                                
                                <div class="stats-box-icon-bg" style="top: 100px;"></div>
                                <div class="stats-box-icon" style="top: 100px;">
                                <i class="mdi mdi-star"></i>
                                </div>

                                <div class="clearfix"></div>
                                
                                <div style="float: left;">
                                <v-rating
                                    class="mt-1 -ml-1"
                                    :value="(parseFloat(search.properties.business.rating) || 0)"
                                    :color="'orange ligten-1'"
                                    dense
                                    half-increments
                                    readonly
                                    size="20"
                                ></v-rating>
                                </div>
                                
                                <div class="text-sm pl-2" style="color: #757575; float: left; font-size: 12px; padding-top: 7px;">
                                Based on

                                <span class="mr-1">{{ search.properties.business.user_ratings_total || 0 }}</span>

                                <span class="text-gray-600" v-show="search.properties.business.user_ratings_total == 1">Review</span>
                                <span class="text-gray-600" v-show="search.properties.business.user_ratings_total != 1">Reviews</span>
                                </div>

                                <div class="clearfix"></div>

                                <hr class="mt-3" />

                                <div v-html="reviews_html" style="padding-top: 10px; color: #757B89; font-size: 12px;"></div>
                            </div>
                        </v-card>
                        </div>

                        <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                        <v-card
                            class="pa-2"
                            tile
                        >
                            <div class="p-2">
                                <div class="lr-report-subtitle">Keywords </div>

                                <div style="font-size: 12px; line-height: 20px; padding-top: 5px; color: #757B89;">The review keyword analysis works best with the English language, showing most frequenty used words in your reviews.</div>

                                <br />

                                <div v-for="(topic, index_topic) in topics" :key="index_topic" style="padding: 8px 15px; display: inline-block; margin-right: 20px; margin-bottom: 10px; font-size: 12px; background: rgba(25, 35, 58, 0.05); color: #19233A; border-radius: 5px; padding-top: 10px;">
                                    {{ topic }}

                                    <!-- <div style="float: right; padding: 2px; padding-left: 3px; padding-right: 3px; background: #D9D9D9; border-radius: 3px; margin-left: 5px; margin-top: -2px;">{{ topic.mentions }}</div> -->
                                </div>
                                

                            </div>
                        </v-card>
                        </div>
                    </div>
                </div>
                <div v-else class="pt-3">
                    <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'px-3' : 'pl-3') + ' mb-3'" style="font-size: 12px; color: #273042;"><i class="fa fa-spin fa-spinner"></i> Please wait while we import all your reviews.</div>

                    <v-skeleton-loader type="article, article, article, article, article, article"></v-skeleton-loader>
                </div>
            </div>
        </div>

        <div v-show="gmb_tab == 4 || $vuetify.breakpoint.xs || this.$route.query.download">
            <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? '' : 'px-3')">
                <div v-if="search.properties.posts.grade">
                    <div v-if="search.properties.posts.status !== 'Error Occured'">
                            <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                <v-card
                                    class="pa-2 pt-6 pb-6"
                                    tile

                                    :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'pl-3' : '')"
                                >
                                <div class="flex flex-row flex-wrap">
                                    <div class="w-full lg:w-1/2" style="position: relative;">
                                        <div class="lr-seo-box-left">
                                            <div class="lr-doughnut-wrapper">
                                            <div class="lr-doughnut-title">
                                                {{ search.properties.posts.grade.value }}
                                            </div>
                                                <apexchart type="donut" :options="postsDoughnut.chartOptions" :series="postsDoughnut.series" width="200"></apexchart>
                                            </div>
                                        </div>

                                        <div class="lr-seo-box-right pt-4">
                                            <div class="" style="font-size: 20px; font-weight: bold;">
                                                {{ search.properties.posts.grade.title }}
                                            </div>

                                            <div style="color: #757B89; font-size: 12px;">
                                                {{ search.properties.posts.grade.description }}
                                            </div>
                                        </div>

                                        <div class="clearfix"></div>
                                    </div>

                                    <div class="w-full lg:w-1/2" :style="'position: relative; ' + (($vuetify.breakpoint.xs) ? '' : 'border-left: solid 1px rgba(0, 0, 0, 0.1); padding-left: 30px;') + ' '">
                                        <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'pt-2' : 'float-right pr-2')">
                                            <span v-if="search.properties.posts.grade.value == 'A+'"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i> Passed</span>
                                            <span v-if="search.properties.posts.grade.value != 'A+'"><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i> Failed</span>
                                        </div>
                                        
                                        <div v-if="search.properties.gbp_issues.items" style="">
                                            <div :style="(($vuetify.breakpoint.xs) ? 'padding-top: 10px;' : 'padding-top: 25px;')">
                                                <span v-if="search.properties.posts.posted_last_week"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i>  Last week posting</span>
                                                <span v-else><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i>  Last week posting</span>
                                            </div>

                                            <div :style="(($vuetify.breakpoint.xs) ? 'padding-top: 10px;' : 'padding-top: 25px;')">
                                                <span v-if="search.properties.posts.posting_frequency_good"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i>  Posting frequency</span>
                                                <span v-else><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i>  Posting frequency</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                        </div>

                        <div>
                            <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                <v-card
                                    class="pa-2 pt-2 pb-6"
                                    tile
                                >
                                    <v-container class="chart-container">
                                        <apexchart height="205" type="line" :options="posts_options" :series="posts_series" :key="posts_chart_key"></apexchart>
                                    </v-container>
                                </v-card>
                            </div>
                        </div>

                        <div class="flex flex-row flex-wrap mb-4">
                            <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Total Posts Analyzed</div>

                                <div class=""><strong class="text-xl">{{ search.properties.posts.list.length }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-file-document"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                            <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Post Frequency (Last 30 Days)</div>

                                <div class=""><strong class="text-xl">{{ search.properties.posts.post_frequency }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-clock-outline"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                            <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Average Characters Per Post</div>

                                <div class=""><strong class="text-xl">{{ search.properties.posts.average_characters_per_post }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-xml"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                            <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Average No. Of Words Per Post</div>

                                <div class=""><strong class="text-xl">{{ search.properties.posts.average_words_per_post }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-xml"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                            <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Total No. Of Posts With Links</div>

                                <div class=""><strong class="text-xl">{{ search.properties.posts.posts_with_links }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-link"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>

                            <div class="dashboard-box stats-box w-full px-2 md:w-1/3 lg:w-1/3 mb-5">
                            <v-card
                                class="pa-2"
                                tile
                            >
                                <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'p-1' : 'p-3')">
                                <div class="dashboard-box-title">Total No. of Posts With Images</div>

                                <div class=""><strong class="text-xl">{{ search.properties.posts.posts_with_images }}</strong></div>
                                
                                <div class="stats-box-icon-bg"></div>
                                <div class="stats-box-icon">
                                    <i class="mdi mdi-camera-outline"></i>
                                </div>
                                </div>
                            </v-card>
                            </div>
                        </div>

                        <div class="flex flex-row flex-wrap">
                            <div class="w-full" style="position: relative;">
                                <div style="">
                                    <div>
                                        <div class="dashboard-box stats-box w-full px-2">
                                            <v-card
                                                class="pa-2 pt-2 pb-6"
                                                tile
                                            >
                                                <div style="/*cursor: pointer;*/" @click="/*showSeoOnPageCategoryDescription(item.title, item.description)*/">
                                                    <div style="padding: 10px;">
                                                        <div style="font-weight: bold; font-size: 16px;">Posts Comparison</div>

                                                        <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                            Posting frequently is important because that shows your company is active, your users will love that and it will increase sales.
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-row flex-wrap">
                            <div v-for="(item2, index2) in search.properties.competitors.list" :key="index2" class="dashboard-box stats-box w-full px-2 mb-5 mt-3" :class="'lg:w-1/' + search.properties.competitors.list.length">
                                <v-card class="pa-2" tile :style="((item2.my_business) ? 'background: #19233A; color: #FFFFFF !important;' : '')">
                                    <div class="p-2 pl-3" style="position: relative;">
                                        <div class="dashboard-box-title" style="width: calc(100% - 70px);"><a style="font-size: 12px;" :style="((item2.my_business) ? 'color: #FFFFFF !important;' : 'color: #19233A !important;')" :href="'https://www.google.com/search?q=' + encodeURIComponent(item2.name) + ' ' + item2.address" target="lr-competitor">{{ ((item2.my_business) ? "Your Business" : item2.name) }}</a></div>

                                        <div class="details-box top-heading" style="width: calc(100% - 70px);">Has Posts: <strong>{{ ((item2.has_posts) ? 'Yes' : 'No') }}</strong></div>

                                        <div v-if="search.properties.competitors.competitors_frequency" class="details-box top-heading" style="width: calc(100% - 70px);">Posting Frequency: <strong>{{ item2.posts_frequency }}</strong></div>

                                        <div class="stats-box-icon-bg"></div>
                                        <div class="stats-box-icon">
                                            <i class="mdi mdi-file-document"></i>
                                        </div>
                                    </div>
                                </v-card>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                <v-card
                                        class="pa-2 pt-6 pb-6"
                                        tile

                                        :class="(($vuetify.breakpoint.xs) ? 'pl-3' : '')"
                                    >
                                        <div class="flex flex-row flex-wrap">
                                            <div class="w-full" style="position: relative;">

                                                <div class="lr-seo-box-right pt-3">
                                                 <strong class=""> Error :</strong> We are facing some delays because of API failure. We are retrying to fetch results for this report.
                                                </div>

                                                <div class="clearfix"></div>
                                            </div>
                                        </div>
                                </v-card>
                            </div>
                    </div>
                </div>
                <div v-else class="pt-3">
                    <div :class="(($vuetify.breakpoint.xs || this.$route.query.download) ? 'px-3' : 'pl-3') + ' mb-3'" style="font-size: 12px; color: #273042;"><i class="fa fa-spin fa-spinner"></i> Please wait while we import all your posts.</div>

                    <v-skeleton-loader type="article, article, article, article, article, article"></v-skeleton-loader>
                </div>
            </div>
        </div>

        <div v-show="gmb_tab == 5 || $vuetify.breakpoint.xs">
            <div :class="(($vuetify.breakpoint.xs) ? '' : 'px-3')">
                <!-- <strong style="font-size: 16px; color: #273042;">Overview</strong> -->

                <div v-if="search.properties.gbp_issues.grade">
                    <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                            <v-card
                                class="pa-2 pt-6 pb-6"
                                tile

                                :class="(($vuetify.breakpoint.xs) ? 'pl-3' : '')"
                            >
                            <div class="flex flex-row flex-wrap">
                                <div class="w-full lg:w-1/2" style="position: relative;">
                                    <div class="lr-seo-box-left">
                                        <div class="lr-doughnut-wrapper">
                                        <div class="lr-doughnut-title">
                                            {{ search.properties.gbp_issues.grade.value }}
                                        </div>
                                            <apexchart type="donut" :options="gbpDoughnut.chartOptions" :series="gbpDoughnut.series" width="200"></apexchart>
                                        </div>
                                    </div>

                                    <div class="lr-seo-box-right pt-4">
                                        <div class="" style="font-size: 20px; font-weight: bold;">
                                            {{ search.properties.gbp_issues.grade.title }}
                                        </div>

                                        <div style="color: #757B89; font-size: 12px;">
                                            {{ search.properties.gbp_issues.grade.description }}
                                        </div>
                                    </div>

                                    <div class="clearfix"></div>
                                </div>

                                <div class="w-full lg:w-1/2" :style="'position: relative; ' + (($vuetify.breakpoint.xs) ? '' : 'border-left: solid 1px rgba(0, 0, 0, 0.1); padding-left: 30px;') + ' '">
                                    <div class="float-right pr-2">
                                        <span v-if="search.properties.gbp_issues.grade.value == 'A+'"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i> Passed</span>
                                        <span v-if="search.properties.gbp_issues.grade.value != 'A+'"><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i> Failed</span>
                                    </div>
                                    
                                    <div v-if="search.properties.gbp_issues.items" style="">
                                        <div v-for="(item, index) in search.properties.gbp_issues.items" :key="index" style="padding-top: 15px;">
                                            <span v-if="item.passed === true"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i>  {{ item.title }}</span>
                                            <span v-if="item.passed === false"><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i>  {{ item.title }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-card>
                    </div>

                    <div v-if="search.properties.gbp_issues.items" style="">
                        <div v-for="(item, index) in search.properties.gbp_issues.items" :key="index">
                            <div v-if="search.properties.summary.grade" class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                <v-card
                                    class="pa-2 pt-2 pb-6"
                                    tile
                                >
                                    <div style="/*cursor: pointer;*/" @click="/*showSeoOnPageCategoryDescription(item.title, item.description)*/">
                                        <div class="float-right pr-2">
                                            <div v-if="item.title == 'NAP Comparisons' && (search.properties.competitors.status == 'pending' || search.properties.competitors.status === 'fetch_report_details')">
                                                <i class="mdi mdi-information-outline" style="color: #757B89; font-size: 18px;"></i> Pending
                                            </div>
                                            <div v-else>
                                                <span v-if="item.passed === true"><i class="mdi mdi-check-circle-outline" style="color: #54AC0E; font-size: 18px;"></i> Passed</span>
                                                <span v-if="item.passed === false || search.properties.competitors.status === 'Error Occured'"><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i> Failed</span>
                                            </div>
                                        </div>

                                        <div style="padding: 10px;">
                                            <div style="font-weight: bold; font-size: 16px;">{{ item.title }}</div>

                                            <div v-if="item.sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                {{ item.sub_title }}
                                            </div>

                                            <div v-if="item.sub_sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                {{ item.sub_sub_title }}
                                            </div>

                                            <div v-if="item.title != 'NAP Comparisons' || (item.title == 'NAP Comparisons' && search.properties.competitors.status == 'completed')" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                {{ item.description }}
                                            </div>

                                            <div v-if="item.title == 'NAP Comparisons'">
                                                <div v-if="search.properties.competitors.status == 'completed'">
                                                    <table class="w-full rg-datatable mt-5">
                                                        <thead class="border-b border-gray-100 w-full">
                                                        <tr>
                                                            <th>Source</th>
                                                            <th>Need to fix</th>
                                                            <th>&nbsp;</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody class="w-full" style="">
                                                            <tr v-for="(item_citation, index_citation) in search.properties.business.citations_report.active" :key="index_citation">
                                                                <td v-if="item_citation.need_to_fix.length > 0" class="">
                                                                    <a :href="'https://' + item_citation.source" target="lr-missing-citation">{{ item_citation.source }}</a>
                                                                </td>
                                                                <td v-if="item_citation.need_to_fix.length > 0" class="">
                                                                    {{ item_citation.need_to_fix.join(", ") }}

                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M13.5201 13.6288H4.47896C3.70853 13.6304 2.99547 13.2215 2.60783 12.5556C2.22011 11.8898 2.21648 11.0678 2.59819 10.3985L7.22676 1.87117V1.87127C7.47777 1.42469 7.87926 1.08187 8.3597 0.903975C8.84005 0.726083 9.36809 0.724676 9.84933 0.900057C10.3307 1.07544 10.734 1.41614 10.9873 1.86144L15.4071 10.4125V10.4126C15.7823 11.0818 15.7743 11.9 15.3861 12.5618C14.9977 13.2237 14.2875 13.6299 13.5202 13.6289L13.5201 13.6288ZM9.11164 1.80022C8.91115 1.79872 8.71397 1.85085 8.5405 1.95129C8.36703 2.05184 8.2237 2.19689 8.12527 2.37157L3.4967 10.8938V10.903C3.2961 11.2537 3.29711 11.6846 3.49951 12.0343C3.70191 12.3839 4.07497 12.5995 4.47897 12.6002H13.5201C13.9245 12.6004 14.2985 12.3851 14.5015 12.0354C14.7045 11.6855 14.7058 11.2541 14.505 10.903L10.0852 2.35252C9.98617 2.18277 9.84384 2.04215 9.67288 1.94521C9.50192 1.84818 9.30826 1.79815 9.1117 1.80017L9.11164 1.80022Z" fill="#F03737"/>
                                                                        <path d="M9.77137 10.5429C9.77137 10.969 9.42603 11.3143 8.99994 11.3143C8.57386 11.3143 8.22852 10.969 8.22852 10.5429C8.22852 10.1168 8.57386 9.77148 8.99994 9.77148C9.42603 9.77148 9.77137 10.1168 9.77137 10.5429Z" fill="#F03737"/>
                                                                        <path d="M9.22832 9.02831C9.22028 9.14875 9.12024 9.24236 8.9995 9.24236C8.87877 9.24236 8.77872 9.14875 8.77069 9.02831L8.14017 5.24111H8.14007C8.08583 4.97492 8.14911 4.6982 8.31375 4.48213C8.47838 4.26597 8.72839 4.13156 8.99949 4.11328C9.2706 4.13156 9.52062 4.26596 9.68524 4.48213C9.84987 4.69819 9.91316 4.97492 9.85891 5.24111L9.22832 9.02831Z" fill="#F03737"/>
                                                                    </svg>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div v-else>
                                                    <br />
                                                    <i class="fa fa-spin fa-spinner"></i>
                                                </div>
                                            </div>

                                            <div v-if="item.title == 'Local Ranking Factors'">
                                                <table class="w-full rg-datatable mt-5">
                                                    <thead class="border-b border-gray-100 w-full">
                                                    <tr>
                                                        <th>Local Search Factor</th>
                                                        <th>Yes / No</th>
                                                        <th>What we looked for</th>
                                                        <th>&nbsp;</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody class="w-full" style="">
                                                    <tr v-for="(ranking_factor, index4) in item.ranking_factors" :key="index4">
                                                        <td class="">
                                                            {{ ranking_factor.title }}
                                                        </td>
                                                        <td class="">
                                                            {{ ranking_factor.value }}
                                                        </td>
                                                        <td class="">
                                                            {{ ranking_factor.what_we_looked_for }}
                                                        </td>
                                                        <td class="">
                                                            <span v-if="ranking_factor.type == 'local_number'">
                                                                {{ ranking_factor.description }}
                                                            </span>

                                                            <span v-if="search.properties.business.website && ranking_factor.type == 'city_title_tag' || ranking_factor.type == 'state_title_tag'">
                                                                <a :href="search.properties.business.website" target="gbp-issues-website">View Landing Page</a>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    <div style="clear: both;"></div>  

                                    </div>
                                </v-card>
                            </div>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </div>
                <div v-else class="pt-3">
                    <v-skeleton-loader type="article, article, article, article, article, article"></v-skeleton-loader>
                </div>
            </div>
        </div>

        <div v-show="gmb_tab == 6 || $vuetify.breakpoint.xs">
            <div :class="'text-bold ' + (($vuetify.breakpoint.xs) ? '' : 'px-3')">
                <div v-if="search.properties.gbp_issues.grade">
                    <div v-if="search.properties.recommendations.items" class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                            <v-card
                                class="pa-2 pt-6 pb-6"
                                tile

                                :class="(($vuetify.breakpoint.xs) ? 'pl-3' : '')"
                            >
                                <div v-for="(item_recommendation, index5) in search.properties.recommendations.items" :key="index5" style="display: inline-block; padding-right: 15px;">
                                    <span><i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 15px;"></i>  {{ item_recommendation.title }}</span>
                                </div>
                        </v-card>
                    </div>

                    <div class="flex flex-row flex-wrap">
                        <div class="w-full lg:w-2/3" style="position: relative;">
                            <div v-if="search.properties.recommendations.items" style="">
                                <div v-for="(item, index) in search.properties.recommendations.items" :key="index">
                                    <div v-if="search.properties.summary.grade" class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                        <v-card
                                            class="pa-2 pt-2 pb-6"
                                            tile
                                        >
                                            <div style="/*cursor: pointer;*/" @click="/*showSeoOnPageCategoryDescription(item.title, item.description)*/">
                                                <div class="float-left pr-2" style="width: 25px;">
                                                    <i class="mdi mdi-alert-circle-outline" style="color: red; font-size: 18px;"></i>
                                                </div>

                                                <div class="float-left" style="width: calc(100% - 25px);">
                                                    <div style="font-weight: bold; font-size: 16px;">{{ item.title }}</div>

                                                    <div v-if="item.sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        {{ item.sub_title }}
                                                    </div>

                                                    <div v-if="item.sub_sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        {{ item.sub_sub_title }}
                                                    </div>

                                                    <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        <strong>{{ item.description }}</strong>
                                                    </div>
                                                </div>

                                            <div style="clear: both;"></div>  

                                            </div>
                                        </v-card>
                                    </div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </div>

                        <div class="w-full lg:w-1/3 p-3" style="position: relative;">
                            <img src="https://regro-cdn.s3.amazonaws.com/images/iphone_bg.png" style="position: absolute; width: 90%;" />
                            <img v-if="search.properties.mobile_screenshot" :src="search.properties.mobile_screenshot" style="position: relative; margin-top: 50px; width: 86%; border-radius: 10px; margin-left: 22px;" />

                            <br /><br />
                        </div>
                    </div>
                </div>
                <div v-else class="pt-3">
                    <v-skeleton-loader type="article, article, article, article, article, article"></v-skeleton-loader>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  
  <script>
  import axios from 'axios'
  import moment from 'moment'
  import $ from 'jquery'
  import ApexCharts from 'apexcharts'
  import VueGauge from "@/views/local-recon/VueGauge";
  
  export default {
    props: ['search', 'ignore_header'],

    components: {
        ApexCharts,
    },

    data () {
        return {
            faq_keywords: "",
            reviews_html: "",
            negative_reviews_html: "",
        
            sentiment_data: [],

            gmb_tab: 0,

            loaded: false,

            show_grid: false,

            seo_audit_grades: {
                "A+": 100,
                "A": 85,
                "A-": 70,
                "B+": 69,
                "B": 65,
                "B-": 60,
                "C+": 59,
                "C": 55,
                "C-": 50,
                "D+": 49,
                "D": 45,
                "D-": 40,
                "E+": 39,
                "E": 35,
                "E-": 30,
                "F+": 29,
                "F": 20,
                "F-": 10
            },

            shortSummaryDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#3EBB80', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            summaryDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#2477F6', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            gbpDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#FFB443', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            reviewsDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#3EBB80', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            reviews_options: {
                chart: {
                id: 'vuechart-example',
                toolbar: {
                    show: false
                },
                legend: {
                    show: true
                }
                },
                xaxis: {
                categories: [],
                tickAmount: 10,
                labels: {
                        rotate: 0
                    }
                }
            },
            reviews_series: [],

            reviews_chart_key: 0,

            postsDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#3EBB80', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            posts_options: {
                chart: {
                id: 'vuechart-example',
                toolbar: {
                    show: false
                },
                legend: {
                    show: true
                }
                },
                xaxis: {
                categories: [],
                tickAmount: 10,
                labels: {
                        rotate: 0
                    }
                }
            },
            posts_series: [],

            posts_chart_key: 0,

            reviews_html: ""
        }
    },
    methods: {
        ucwords (str) {
            return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
                return $1.toUpperCase();
            });
        },
    
        async runCreated() {
            
            let self = this

            if (!self.search.properties.success) {
                this.show_grid = true;
            }

            if (this.search.properties.grid.status != 'completed') {
                
                let logo = "https://reviewgrower.com/wp-content/uploads/2021/09/reviewgrower-blue-green-middle-e1652210601332.png";

                window.RG_GRID_CONFIG = {
                    API_URL: process.env.VUE_APP_API_ENDPOINT,
                    USER: {
                        uuid: this.search.uuid
                    },
                    LOGO: logo,
                    COMPANY_NAME: this.search.company_name,
                    GOOGLE_MAPS_KEY: this.search.api_key,
                    VALUE_SERP_KEY: "",
                    SAB_ENABLED: 0
                }
                
                window.RG_GRID_ACTION = {
                    ACTION: "scan_lr_gmb",
                    g: btoa(unescape(encodeURIComponent(JSON.stringify(self.search.properties.business)))),
                    q: self.search.properties.business.types[0]
                }
                

                window.saveGridReportId = function(scanId) {
                

                    let response = axios.post(process.env.VUE_APP_API_ENDPOINT + '/local-recon/save-report-grid-id', {
                        report_id: self.search.id,
                        grid_id: scanId
                    } , {
                    headers: {
                        'Authorization': 'Bearer ' + self.$store.state.auth.jwt
                    },
                    })
           
                }
   

            }
            else {

                let logo = "https://reviewgrower.com/wp-content/uploads/2021/09/reviewgrower-blue-green-middle-e1652210601332.png";

                window.RG_GRID_CONFIG = {
                    API_URL: process.env.VUE_APP_API_ENDPOINT,
                    USER: {
                        uuid: this.search.uuid
                    },
                    LOGO: logo,
                    COMPANY_NAME: this.search.company_name,
                    GOOGLE_MAPS_KEY: this.search.api_key,
                    VALUE_SERP_KEY: "",
                    SAB_ENABLED: 0
                }

                window.RG_GRID_ACTION = {
                    ACTION: "view",
                    SCAN_ID: self.search.properties.grid.grid_id
                }
            }

            this.loaded = true;

            if (this.search.properties.short_summary.grade) {
                this.shortSummaryDoughnut.series = [this.seo_audit_grades[this.search.properties.short_summary.grade.value], (100 - this.seo_audit_grades[this.search.properties.short_summary.grade.value])];
            }

            if (this.search.properties.summary.grade) {
                this.summaryDoughnut.series = [this.seo_audit_grades[this.search.properties.summary.grade.value], (100 - this.seo_audit_grades[this.search.properties.summary.grade.value])];
            }

            if (this.search.properties.gbp_issues.grade) {
                this.gbpDoughnut.series = [this.seo_audit_grades[this.search.properties.gbp_issues.grade.value], (100 - this.seo_audit_grades[this.search.properties.gbp_issues.grade.value])];
            }

            setTimeout(function() {
                if (self.search.properties.reviews.grade) {
                    self.reviewsDoughnut.series = [self.seo_audit_grades[self.search.properties.reviews.grade.value], (100 - self.seo_audit_grades[self.search.properties.reviews.grade.value])];

                    self.reviews_options.xaxis.categories = self.search.properties.reviews.chart_data.labels;
                    self.reviews_series = [];

                    if (self.$vuetify.breakpoint.xs) {
                        self.reviews_options.xaxis.labels.show = false;
                    }

                    // console.log('self.search.properties.reviews.chart_data', self.search.properties.reviews.chart_data);

                    for (var dataset_i in self.search.properties.reviews.chart_data.datasets) {

                        for (var j in self.search.properties.reviews.chart_data.datasets[dataset_i]) {
                            self.search.properties.reviews.chart_data.datasets[dataset_i][j] = parseFloat(self.search.properties.reviews.chart_data.datasets[dataset_i][j]);
                        }

                        self.reviews_series.push({
                            name: dataset_i,
                            data: self.search.properties.reviews.chart_data.datasets[dataset_i]
                        });
                    }

                    console.log('self.reviews_options', self.reviews_options)
                    console.log('self.reviews_series', self.reviews_series)

                    self.reviews_chart_key++;
                }
            }, 100);

            setTimeout(function() {
                if (self.search.properties.posts.grade) {
                    self.postsDoughnut.series = [self.seo_audit_grades[self.search.properties.posts.grade.value], (100 - self.seo_audit_grades[self.search.properties.posts.grade.value])];

                    self.posts_options.xaxis.categories = self.search.properties.posts.chart_data.labels;
                    self.posts_series = [];

                    if (self.$vuetify.breakpoint.xs) {
                        self.posts_options.xaxis.labels.show = false;
                    }

                    // console.log('self.search.properties.posts.chart_data', self.search.properties.posts.chart_data);

                    for (var dataset_i in self.search.properties.posts.chart_data.datasets) {

                        for (var j in self.search.properties.posts.chart_data.datasets[dataset_i]) {
                            self.search.properties.posts.chart_data.datasets[dataset_i][j] = parseFloat(self.search.properties.posts.chart_data.datasets[dataset_i][j]);
                        }

                        self.posts_series.push({
                            name: dataset_i,
                            data: self.search.properties.posts.chart_data.datasets[dataset_i]
                        });
                    }

                    console.log('self.posts_options', self.posts_options)
                    console.log('self.posts_series', self.posts_series)

                    self.posts_chart_key++;
                }
            }, 100);

            let reviews_html = "";

            if (this.search.properties.business.reviews.length == 0) {
                reviews_html = '<div class="pt-2">No reviews found.</div>';
            }
            else {
                for (var i in this.search.properties.business.reviews) {
                    let stars_html = '';
        
                    // console.log('review details', this.search.properties.business.reviews[i])
        
                    for (var j = 0; j < 5; j++) {
                        if (j + 1 <= this.search.properties.business.reviews[i].rating)
                            stars_html += '<i class="mdi mdi-star" style="color: #FFB443; font-size: 14px; margin-left: 2px;"></i>';
                        else
                            stars_html += '<i class="mdi mdi-star-outline" style="font-size: 14px; margin-left: 2px;"></i>';
                    }
        
                    if (this.search.properties.business.reviews[i].text.length > 180)
                        this.search.properties.business.reviews[i].text = this.search.properties.business.reviews[i].text.substring(0, 180) + '...';

                        // console.log('this.search.properties.business.reviews[i].relative_time_description', this.search.properties.business.reviews[i].relative_time_description)
        
                    let this_html = '<div style="padding-bottom: 10px; border-bottom: 1px solid rgba(0, 0, 0, 0.05); margin-bottom: 10px;">\
                        <div style=""><strong>' + this.search.properties.business.reviews[i].author_name + '</strong> <em style="font-size: 11px;">' + this.search.properties.business.reviews[i].relative_time_description + '</em></div>\
                        <div style="float: right; margin-top: -25px;">\
                            <img src="https://regro-cdn.s3.amazonaws.com/images/review-services/www.google.com.png" style="height: 40px;" />\
                        </div>\
                        <div style="padding-top: 5px;">\
                        <strong>' + this.search.properties.business.reviews[i].rating + '</strong> ' + stars_html + '\
                        </div>\
                        <div style="font-size: 12px; line-height: 20px; padding-top: 5px; color: #757B89;">\
                            ' + this.search.properties.business.reviews[i].text + '\
                        </div>\
                    </div>';
        
                    reviews_html += this_html;
                }
            }

            this.reviews_html = reviews_html;
        }
    },
    created() {
        let self = this
        // console.log('search', this.search);

        setTimeout(function() {
            self.runCreated();
        }, 2000);
    }
  }
  </script>